import { required, minLength } from "vuelidate/lib/validators";

export const PASSWORD_MIN_LENGTH = 8;

export const PASSWORD_REGEX = {
  UPPERCASE: /[A-Z]/,
  LOWERCASE: /[a-z]/,
  NUMBER: /[0-9]/,
  SPECIAL_CHAR: /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>?/]/,
};

export const passwordValidators = {
  required,
  minLength: minLength(PASSWORD_MIN_LENGTH),
  hasUppercase: (value) => !value || PASSWORD_REGEX.UPPERCASE.test(value),
  hasLowercase: (value) => !value || PASSWORD_REGEX.LOWERCASE.test(value),
  hasNumber: (value) => !value || PASSWORD_REGEX.NUMBER.test(value),
  hasSpecialChar: (value) => !value || PASSWORD_REGEX.SPECIAL_CHAR.test(value),
};

export const PASSWORD_MESSAGES = {
  required: "The password is required",
  minLength: `Password must be at least ${PASSWORD_MIN_LENGTH} characters long`,
  hasUppercase: "Password must contain at least one uppercase letter",
  hasLowercase: "Password must contain at least one lowercase letter",
  hasNumber: "Password must contain at least one number",
  hasSpecialChar: "Password must contain at least one special character",
};